import { Col, Row } from "antd";
import AssetPath from "../../AssetPath/AssetPath";
import PageTitle from "../../Components/PageTitle/PageTitle";
import TeamData from "../../Util/TeamData";
import AboutSection from "../LandingPage/AboutSection";
import CTA from "../LandingPage/CTA";

export default function AboutUs() {
  return (
    <>
      <PageTitle
        mainTitle="About Us"
        breadcrumbItems={[{ name: "About Us", path: "/about-us" }]}
        image={AssetPath.breadcrumb.aboutUsImage}
      />

      <AboutSection />

      <section className="who-we-are spacing bg-primary">
        <div className="container">
          <Row
            gutter={[
              { xs: 10, sm: 16, md: 24, lg: 24 },
              { xs: 10, sm: 16, md: 24, lg: 24 },
            ]}
            justify="center"
            align="middle"
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 18 }}
              md={{ span: 18 }}
              lg={{ span: 18 }}
              data-aos="fade-up"
            >
              <h4 className="title mb-3 text-white fw-bold">
                About the Annual Conference:
              </h4>
              <p className="text-white">
                The conference's core objective is to fortify the professional
                development of pharmaceutical analytics personnel. It offers a
                rich blend of insightful speaker sessions (lasting approximately
                45 minutes) and in-depth panel discussions (ranging from 45
                minutes to an hour) focused on pivotal industry topics,
                including industry trend, GCC opportunities, Data Strategy,
                emerging data providers, GenAI/LLM-based approaches, and their
                applicability within the pharmaceutical sector.
              </p>
              <p className="text-white">
                Furthermore, structured networking sessions are also
                incorporated to ensure meaningful interactions among
                participants.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      <section className="attendee-benefits spacing bg-white">
        <div className="container">
          <Row
            gutter={[
              { xs: 10, sm: 16, md: 24, lg: 24 },
              { xs: 10, sm: 16, md: 24, lg: 24 },
            ]}
            justify="center"
            align="top"
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 20 }}
              md={{ span: 18 }}
              lg={{ span: 18 }}
              data-aos="fade-up"
            >
              <h4 className="title mb-4 text-primary fw-bold">
                Attendees will benefit by
              </h4>
              <ul className="list-unstyled pl-5 space-y-2 text-gray-700 text-base ">
                <li className="font-18">
                  💡 Gain insights from industry thought leaders
                </li>
                <li className="font-18">
                  🧪 Acquire hands-on training in cutting-edge methodologies
                </li>
                <li className="font-18">
                  🌉 Bridge the gap between analytics techniques and business
                  applications
                </li>
                <li className="font-18">
                  🔍 Discover innovative data sources and strategies
                </li>
                <li className="font-18">🤝 Broaden professional connections</li>
                <li className="font-18">
                  📦 Explore new data science offerings from suppliers
                </li>
                <li className="font-18">
                  📈 Keep informed about evolving industry trends
                </li>
                <li className="font-18">
                  🏢 Comprehend real-world business hurdles
                </li>
                <li className="font-18">
                  🔓 Dismantle organizational barriers
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </section>

      <section className="our-team spacing bg-light-green position-relative">
        <div className="container">
          <div className="team-list">
            <Row
              gutter={[
                { xs: 0, sm: 16, md: 24, lg: 32 },
                { xs: 0, sm: 16, md: 24, lg: 20 },
              ]}
              align="center"
              justify="middle"
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 20 }}
                lg={{ span: 20 }}
              >
                <h3 className="text-center title mb-3 text-primary fw-bold text-capitalize">
                  Board of Directors
                </h3>
                <Row
                  gutter={[
                    { xs: 0, sm: 15, md: 15, lg: 15 },
                    { xs: 0, sm: 5, md: 5, lg: 5 },
                  ]}
                  align="start"
                >
                  {TeamData.boardMembers.map((members, i) => (
                    <Col
                      xs={{ span: 12 }}
                      sm={{ span: 12 }}
                      md={{ span: 6 }}
                      lg={{ span: 6 }}
                      data-aos="fade-up"
                      key={i}
                    >
                      <div className="team-details img-spacing position-relative">
                        <div className="profile-image rounded overflow-hidden">
                          <img
                            src={members.profileImage}
                            alt={members.name}
                            className="w-100 rounded"
                          />
                        </div>
                        <div className="details text-center card">
                          <h4 className="text-ellipsis1 font-4 font-weight-bold mb-1">
                            {members.name}
                          </h4>
                          <p className="text-ellipsis2 mb-0">
                            {members.position}
                          </p>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
                <h3 className="text-center title mt-4 mb-3 text-primary fw-bold text-capitalize">
                  Industry Advisory Committee
                </h3>
                <Row
                  gutter={[
                    { xs: 0, sm: 15, md: 15, lg: 15 },
                    { xs: 0, sm: 5, md: 5, lg: 5 },
                  ]}
                  align="start"
                >
                  {TeamData.IndustryAdvisoryCommittee.map((members, i) => (
                    <Col
                      xs={{ span: 12 }}
                      sm={{ span: 12 }}
                      md={{ span: 6 }}
                      lg={{ span: 6 }}
                      data-aos="fade-up"
                      key={i}
                    >
                      <div className="team-details img-spacing position-relative">
                        <div className="profile-image rounded overflow-hidden">
                          <img
                            src={members.profileImage}
                            alt={members.name}
                            className="w-100 rounded"
                          />
                        </div>
                        <div className="details text-center card">
                          <h4 className="text-ellipsis1 font-4 font-weight-bold mb-1">
                            {members.name}
                          </h4>
                          <p className="text-ellipsis2 mb-0">
                            {members.position}
                          </p>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
                <h3 className="text-center title mt-4 mb-3 text-primary fw-bold text-capitalize">
                  Volunteers
                </h3>
                <Row
                  gutter={[
                    { xs: 0, sm: 15, md: 15, lg: 15 },
                    { xs: 0, sm: 5, md: 5, lg: 5 },
                  ]}
                  align="start"
                >
                  {TeamData.volunteers.map((members, i) => (
                    <Col
                      xs={{ span: 12 }}
                      sm={{ span: 12 }}
                      md={{ span: 6 }}
                      lg={{ span: 6 }}
                      data-aos="fade-up"
                      key={i}
                    >
                      <div className="team-details img-spacing position-relative">
                        <div className="profile-image rounded overflow-hidden">
                          <img
                            src={members.profileImage}
                            alt={members.name}
                            className="w-100 rounded"
                          />
                        </div>
                        <div className="details text-center card">
                          <h4 className="text-ellipsis1 font-4 font-weight-bold mb-1">
                            {members.name}
                          </h4>
                          <p className="text-ellipsis2 mb-0">
                            {members.position}
                          </p>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </section>

      <CTA
        title=""
        noImage
        subTitle="Join Our Board"
        label="Apply to Join"
        desc={
          <>
            <p>
              Are you passionate about building a professional community and
              expanding your network in the industry?
            </p>
            <p>
              We invite you to join the Pharma-SOS board and collaborate with
              leaders in the field. Reach out to learn more!
            </p>
          </>
        }
      />
    </>
  );
}
